/**
 * How a step un-pads the frame card the layout gives it.
 *
 * `.bi-frame`, `.fx-frame` and `.rl-frame` all zero `<FrameCard>`'s own 28px
 * padding: each brings its own, and the hairlines between their bands — or, on
 * Reels, the divider down the middle — have to run the full width of the card,
 * which they cannot do inside a padded box.
 *
 * Extracted at the third caller, which is the point this README predicted it
 * would be worth doing. **Not** a `FrameCard` variant, which is where that note
 * guessed it would land: the card is rendered by `contest-edit-layout.tsx` above
 * the `<Outlet/>` and is shared by all four steps, so a `padded={false}` prop
 * would make the layout hold a list of which steps un-pad — the layout learning
 * each step's interior, to spare each step one line.
 */
import type { Theme } from '@mui/material/styles';

export const frameBleedSx = (theme: Theme) => ({
  margin: `-${theme.tokens.layout.frameCardPadding}px`,
});
